// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2hGL0","editButton":"styles_editButton__3QCD7","deleteButton":"styles_deleteButton__1DsCd","link":"styles_link__UsuX2"};